export default __webpack_public_path__ + "static/media/1917.7b95a944.png";